<template>
  <div class="overflow-y-scroll">
    <h3>Add Comment</h3>
    <section>
      <div class="form-inline">
        <label>Comment:</label>
        <div>
          <textarea rows="3" v-model="editComment" />
        </div>
      </div>
      <div class="form-inline">
        <spinnerButton
          class="submit primary"
          :loading="submitLoading"
          @click.native="buttonClick"
        >Add Comment</spinnerButton>
      </div>
    </section>
  </div>
</template>

<script>
import spinnerButton from "@/components/public/SpinnerButton";

export default {
  props: ["submitLoading"],
  components: {
    spinnerButton
  },
  data() {
    return {
      editComment: null
    };
  },
  created: function() {
    this.initData();
  },
  methods: {
    initData: function() {
      this.editComment = null;
    },
    buttonClick: function() {
      this.$emit("buttonClick", this.editComment);
    }
  }
};
</script>
